import { useState } from 'react';
import ShipDateService from './ShipDateService';

function useShipDate({ manage = 'auto' } = {}) {
    const [shipDates, setShipDates] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const isUnauthorized = (err) => {
        const status = err?.response?.status;
        return status === 401 || status === 403;
    };

    const getShipDates = async () => {
        setIsLoading(true);
        try {
            let response;
            if (manage === true) {
                // หน้าจัดการรอบ — เห็นครบทุกรอบ (รวมอนาคต + ที่ปิดไว้)
                response = await ShipDateService.getShipDatesManage();
                // ซ่อนแถว tombstone ('moved' / 'deleted') ที่ backend เก็บไว้กัน scheduler งอกรอบซ้ำ
                // รอบที่ 'cancelled' ยังแสดงตามเดิม
                response.data = response.data.filter((s) => !['moved', 'deleted'].includes(s.status));
            } else if (manage === false) {
                response = await ShipDateService.getShipDates();
            } else {
                // auto: หน้าเลือกรอบ (picker) — ตัดรอบล่วงหน้า/ที่ปิดไว้ออก แต่ยังเห็นรอบผูกโกดัง
                try {
                    response = await ShipDateService.getShipDatesManage({ operational: true });
                } catch (err) {
                    if (!isUnauthorized(err)) throw err;
                    response = await ShipDateService.getShipDates();
                }
            }
            console.log(response.data)
            setShipDates(response.data);
            setError(null);
        } catch (err) {
            setError(err);
        } finally {
            setIsLoading(false);
        }
    };

    const addShipDate = async (formData) => {
        let result = true
        setIsLoading(true);
        try {
            await ShipDateService.addShipDate(formData);
            await getShipDates();
        } catch (err) {
            result = false
            console.log(err)
            setError(err.response.data.message || 'An error occurred.');
        } finally {
            setIsLoading(false);
        }
        return result
    };

    const editShipDate = async (shipDateId, updatedData) => {
        setIsLoading(true);
        let result = true
        try {
            await ShipDateService.editShipDate(shipDateId, updatedData);
            await getShipDates();
            result = true
        } catch (err) {
            setError(err.response.data.message || 'An error occurred.');
            result = false
        } finally {
            setIsLoading(false);
        }
        return result
    };

    const deleteShipDate = async (shipDateId) => {
        setIsLoading(true);
        let result = true
        try {
            await ShipDateService.deleteShipDate(shipDateId);
            await getShipDates();
            result = true
        } catch (err) {
            setError(err);
            result = false
        } finally {
            setIsLoading(false);
        }
        return result
    };

    return {
        shipDates,
        isLoading,
        error,
        getShipDates,
        addShipDate,
        editShipDate,
        deleteShipDate,
    };
}

export default useShipDate;
